import { FC } from 'react';
import { ToastContainer } from 'react-toastify';
import { RootState, useAppSelector } from '@shared/store';
import { useStyles } from './styles';

export const AppToastContainer: FC = () => {
  const customizer = useAppSelector((state: RootState) => state.customizer);
  const { classes } = useStyles();

  return (
    <ToastContainer
      className={classes.toast}
      position="bottom-right"
      rtl={customizer.activeDir === 'rtl'}
      theme={customizer.activeMode}
    />
  );
};
